export default __webpack_public_path__ + "static/media/A-1.c8f4bd9f.mp3";